<template>
  <VMenu
    transition="slide-y-transition"
    bottom
    :aria-label="translate('aria_label_profile_nav')"
    location="bottom center"
    :open-on-hover="$vuetify.display.mdAndUp"
    open-delay="100"
  >
    <template v-slot:activator="{ props }">
      <button
        type="button"
        v-bind="props"
        id="profile-nav"
        class="font-size-m d-flex flex-column align-center justify-center h-100 px-2 px-md-0"
      >
        <SvgWrapper use="icon_svg_user" dimensions="30" alt="Profil" />
        <a
          :href="customerSoftLoggedIn ? pageUrl.PROFILE || '/' : loginUrl"
          @click="handleAccountLinkClick"
          class="d-none d-md-flex align-center py-1"
        >
          <span
            v-if="customerSoftLoggedIn"
            class="text-uppercase font-size-s text-no-wrap"
          >
            {{ translate('header_navigation_my_account') }}
          </span>
          <span v-else class="text-uppercase font-size-s">{{
            translate('header_navigation_login')
          }}</span>
          <SvgWrapper
            class="ml-1 d-md-none d-lg-inline-block"
            use="icon_svg_down"
            dimensions="17"
            alt="Down"
          />
        </a>
      </button>
    </template>
    <VList v-if="customerSoftLoggedIn">
      <VListItem :href="pageUrl.PROFILE">
        <VListItemTitle>{{
          translate('header_navigation_profile')
        }}</VListItemTitle>
      </VListItem>
      <VListItem :href="pageUrl.ORDERS">
        <VListItemTitle>{{
          translate('header_navigation_orders')
        }}</VListItemTitle>
      </VListItem>
      <VListItem :href="pageUrl.REVIEWS">
        <VListItemTitle>{{
          translate('header_navigation_reviews')
        }}</VListItemTitle>
      </VListItem>
      <VDivider opacity=".75" class="my-2" />
      <VListItem :href="logoutUrl" @click.prevent="goToLogout">
        <VListItemTitle>{{
          translate('header_navigation_logout')
        }}</VListItemTitle>
      </VListItem>
    </VList>
    <VList v-else>
      <VListItem :to="loginUrl" @click.prevent="goToLogin">
        <VListItemTitle>{{
          translate('header_navigation_login')
        }}</VListItemTitle>
      </VListItem>
      <VListItem :to="registerUrl" @click.prevent="goToRegister">
        <VListItemTitle>{{
          translate('header_navigation_register')
        }}</VListItemTitle>
      </VListItem>
    </VList>
  </VMenu>
</template>

<script>
import { useCustomerStore } from '@/stores/customer'
import { mapActions, mapState } from 'pinia'
import SvgWrapper from './SvgWrapper.vue'

export default {
  components: { SvgWrapper },
  computed: {
    ...mapState(useCustomerStore, ['customerSoftLoggedIn']),
    // $route.path instead of location.pathname: same value in the browser,
    // but it also exists during a server render (VIP-12037)
    loginUrl() {
      return `/auth/v2/login?redirect_uri=${this.$route.path}`
    },
    logoutUrl() {
      return this.pageUrl.LOGOUT + `?redirect_uri=${this.$route.path}`
    },
    registerUrl() {
      return `/auth/v2/register?redirect_uri=${this.$route.path}`
    }
  },
  data() {
    return {
      pageUrl: {}
    }
  },
  methods: {
    ...mapActions(useCustomerStore, { logoutCustomer: 'logout' }),
    handleAccountLinkClick(event) {
      if (this.customerSoftLoggedIn) return

      event.preventDefault()
      return this.goToLogin()
    },
    goToLogout() {
      this.logoutCustomer()
      this.clearCacheAndNavigate(this.logoutUrl)
    },
    async goToLogin() {
      await this.clearCache()
      this.$router.push(this.loginUrl)
    },
    async goToRegister() {
      await this.clearCache()
      this.$router.push(this.registerUrl)
    },
    async clearCache() {
      const [{ default: CacheHelper }, { default: BulkProductHelper }] =
        await Promise.all([
          import('@/services/helpers/CacheHelper'),
          import('@/modules/product/BulkProductHelper')
        ])
      await Promise.all([
        await BulkProductHelper.eraseAllCache(),
        await CacheHelper.deleteCache('gatekeeper')
      ])
    },
    async clearCacheAndNavigate(href) {
      await this.clearCache()
      window.location.href = href
    }
  },
  async created() {
    const { PAGE_URL } = await import('@/constants/GlobalConstants')
    this.pageUrl = PAGE_URL
  }
}
</script>
